import {
  SpacerBuilderSettings,
  SpacerPositionOption,
  SpacerTypeOption,
} from '@warebee/shared/data-access-layout-import-converter';
import classNames from 'classnames';
import _ from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { getIndexedTitle } from '../../../../common/utils';
import { Button } from '../../../../components/actions/Button';
import DropdownSelector from '../../../../components/actions/DropdownSelector';
import InputNumber from '../../../../components/inputs/InputNumber';
import { Container } from '../../../../components/layout/ContainerFlex';
import { ActionBar } from '../../../../components/nav/ActionBar';
import Tag from '../../../../helpContext/Tag';
import { ConvertedBayFeature } from '../converter.serializable.model';
import {
  converterAllAreasBuilder,
  converterNewSpacerType,
} from '../store/converter.state';

export type ConverterAddSpacerTableActionProps = {
  selectedBays: ConvertedBayFeature[];
};

const ConverterAddSpacerTableAction: React.FC<
  ConverterAddSpacerTableActionProps
> = props => {
  const { t } = useTranslation('designer');
  const [spacerType, setSpacerType] = useRecoilState(converterNewSpacerType);
  const [spacerPosition, setSpacerPosition] = useState<SpacerPositionOption>(
    SpacerPositionOption.Left,
  );
  const [areaBuilders, setAreaBuilders] = useRecoilState(
    converterAllAreasBuilder,
  );
  const [spacerWidth, setSpacerWidth] = useState<number>(
    // bay?.details?.width ||
    300,
  );

  function addSpacers() {
    const newAreaBuilders = { ...areaBuilders };
    _(props.selectedBays)
      .groupBy(b => b.areaId)
      .forEach((bays, areaId) => {
        const spacers = _.map(bays, bay => {
          const spacersNames = new Set<string>(
            _(areaBuilders[areaId].spacers?.[bay.id])
              .map(s => s.title)
              .value(),
          );
          const title = getIndexedTitle(spacersNames, `${bay.title}-A-`);
          const id = `${areaId}-${bay.id}-${title}`;
          const spacer: SpacerBuilderSettings = {
            id,
            title,
            bayId: bay.id,
            type: spacerType,
            position: spacerPosition,
            width: spacerWidth,
          };
          // add(mutate)
          newAreaBuilders[areaId] = {
            ...newAreaBuilders[areaId],
            spacers: {
              ...newAreaBuilders[areaId].spacers,
              [bay.id]: [
                ...(newAreaBuilders[areaId].spacers?.[bay.id] || []),
                spacer,
              ],
            },
          };
        });
      });

    setAreaBuilders(newAreaBuilders);
  }
  const selectedBaysCount = _.size(props.selectedBays);

  return (
    <Container
      fullWidth={false}
      col
      overflow
      className="bg-menu/30 border-menu relative min-h-24 min-w-[16rem] border-l"
    >
      <ActionBar sticky stickyTop className="text-xxs gap-1 p-2 py-3 uppercase">
        <Button
          label={t('Batch Update bays:', {
            selectedBaysCount: selectedBaysCount,
          })}
          full
          buttonType="primary"
          buttonSize={'xs'}
          className="rounded"
          isDisabled={selectedBaysCount === 0}
          onPress={addSpacers}
        >
          <Tag className="text-menu-active-text bg-transparent px-0.5 text-sm">
            {selectedBaysCount}
          </Tag>
        </Button>
      </ActionBar>

      <div className="flex flex-1 flex-col justify-items-start gap-6 p-4">
        <DropdownSelector
          classNameLabel={classNames('text-xs flex-1 text-menu-text')}
          className={classNames('text-xs')}
          panelMode
          widthFull
          value={spacerPosition}
          values={Object.values(SpacerPositionOption).filter(
            value => typeof value === 'number',
          )}
          renderValue={i => SpacerPositionOption[i]}
          label={t`Position`}
          onChange={(v: SpacerPositionOption) => {
            setSpacerPosition(v);
          }}
        />

        <DropdownSelector
          classNameLabel={classNames('text-xs flex-1 text-menu-text')}
          className={classNames('text-xs')}
          panelMode
          widthFull
          value={spacerType}
          values={Object.values(SpacerTypeOption).filter(
            value => typeof value === 'number',
          )}
          renderValue={i => SpacerTypeOption[i]}
          label={t`Type`}
          onChange={(v: SpacerTypeOption) => {
            setSpacerType(v);
          }}
        />

        <InputNumber
          title={t`Width`}
          className="flex-none"
          inputClassName="text-xs"
          value={spacerWidth}
          onChange={v => setSpacerWidth(v)}
          range={[0, null]}
          debounceInterval={100}
        />
      </div>
    </Container>
  );
};
export default ConverterAddSpacerTableAction;
